<script>
  import InvestorLayout from './components/MenuList'
  import File from '@components/List/File'

  export default {
    page() {
      return {
        title: `利害關係人專區 | 投資人專區`,
      }
    }, 
    components: {
      InvestorLayout,
      File
    },
    props: {
      investorRelation: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {
        activeName: 'employee',
        // list: [
        //   {
        //     title: '員工',
        //     alias: 'employee',
        //     image: require('@assets/images/int/item_1.jpg'),
        //     items: [
        //       {
        //         title: '重要關注議題',
        //         value: this.investorRelation?.employee?.issue || ''
        //       },
        //       {
        //         title: '公司的主要責任',
        //         value: this.investorRelation?.employee?.response || ''
        //       },
        //     ],
        //     contact: {
        //       title: '溝通管道及回應方式',
        //       items: this.investorRelation?.employee?.contact || [],
        //       list: this.investorRelation?.employee?.content || []
        //     }
        //   },
        //   // {
        //   //   title: '供應商',
        //   //   alias: 'supplier',
        //   //   image: require('@assets/images/int/item_1.jpg'),
        //   //   items: [
        //   //     {
        //   //       title: '重要關注議題',
        //   //       value: [
        //   //         '品牌市場形象',
        //   //         '合法與公平交易',
        //   //         '無強迫勞動'
        //   //       ]
        //   //     },
        //   //     {
        //   //       title: '公司的主要責任',
        //   //       value: [
        //   //         '合法與公平交易'
        //   //       ]
        //   //     },
        //   //   ],
        //   //   contact: {
        //   //     title: '溝通管道及回應方式',
        //   //     items: [
        //   //       {
        //   //         name: '黃華明小姐',
        //   //         tel: '(02) 2656-5656，分機688',
        //   //         mail: 'candice.huang@zerone.com.tw',

        //   //       }
        //   //     ],
        //   //     list: ['簽署環保承諾書。',
        //   //       'QBR(Quarterly Business Review)。',
        //   //       '供應商不定期稽核。']
        //   //   }
        //   // },
        //   // {
        //   //   title: '客戶',
        //   //   alias: 'client',
        //   //   image: require('@assets/images/int/item_1.jpg'),
        //   //   items: [
        //   //     {
        //   //       title: '重要關注議題',
        //   //       value: [
        //   //         '客戶服務',
        //   //         '產品責任法規遵循'
        //   //       ]
        //   //     },
        //   //     {
        //   //       title: '公司的主要責任',
        //   //       value: [
        //   //         '提供最具市場競爭力及高品質的產品與服務。',
        //   //         '提供產品服務的整體解決方案，提高客戶滿意度。',
        //   //         '與客戶建立長期緊密而互信的商業夥伴關係。'
        //   //       ]
        //   //     },
        //   //   ],
        //   //   contact: {
        //   //     title: '溝通管道及回應方式',
        //   //     items: [],
        //   //     list: ['請至網站上產品業務聯繫窗口查詢',
        //   //       'QBR(Quarterly Business Review)。',
        //   //       '不定期參與各式技術論壇、硏討會及演說。']
        //   //   }
        //   // },
        //   // {
        //   //   title: '投資',
        //   //   alias: 'investment',
        //   //   image: require('@assets/images/int/item_1.jpg'),
        //   //   items: [
        //   //     {
        //   //       title: '重要關注議題',
        //   //       value: [
        //   //         '財務績效',
        //   //         '公司治理',
        //   //         '未來成長潛力及獲利動力'
        //   //       ]
        //   //     },
        //   //     {
        //   //       title: '公司的主要責任',
        //   //       value: [
        //   //         '遵循主管機關之各項最新法令規範與政策修訂，迅速回應並調整公司資訊揭露形態與內容，以符合法規要求。',
        //   //         '適時提供即時、同步、正確之公司訊息，致力投資資訊之對稱揭露。',
        //   //         '長期穩定的股利政策，提供適當的投資報酬。',
        //   //         '穩健的財務策略，維護良好的公司信用與營運績效。'
        //   //       ]
        //   //     },
        //   //   ],
        //   //   contact: {
        //   //     title: '溝通管道及回應方式',
        //   //     items: [
        //   //       {
        //   //         name: '金可玫小姐 (財務管理處資深協理)',
        //   //         tel: '(02) 2656-5656，分機680',
        //   //         mail: 'cmichelle@zerone.com.tw',

        //   //       },
        //   //       {
        //   //         name: '周良一先生 (資訊管理處資深經理)',
        //   //         tel: '(02) 2656-5656，分機670',
        //   //         mail: 'ken.chou@zerone.com.tw',

        //   //       }
        //   //     ],
        //   //     list: [
        //   //       '年度股東大會。',
        //   //       '定期舉辦法人說明會公布財務報告及營運訊息。',
        //   //       '將即時重大訊息同步公開於證交所公開資訊觀測站與公司網站。',
        //   //       '針對重大事件之公佈，除揭露於公開資訊觀測站與公司網站之外，亦視情況需要不定期發佈新聞稿或召開記者會進行說明。',
        //   //       '於公司網站設立電子郵件信箱與聯絡電話，為投資者與公司之間建立暢通的溝通管道。'
        //   //     ]
        //   //   }
        //   // }
        // ]
      }
    },
    computed: {
      currentList() {
        return this.investorRelation[this.activeName] || {}
        // return this.investorRelation.filter((item, index,) => {
        //   console.log(this.investorRelation[index])
        //   // return item.alias === this.activeName
        // })
      }
    },
    methods: {
      formatKeyName(key) {
        const formateName = {
          employee: '員工',
          customer: '客戶',
          invest: '投資',
          supply: '供應商'
        }
        return formateName[key]
      }
    }
  }
</script>
<template>
  <InvestorLayout>
    <div :class="$style.int">
      <section class="container section">
        <el-tabs v-model="activeName" stretch class="isStyleBase">
          <el-tab-pane
            v-for="(int,key,$index) in investorRelation"
            :key="$index"
            :name="key"
            :label="formatKeyName(key)"
          >
            <div class="row int__list no-gutters">
              <!-- <div class="col-md-5 int__item--left">
                <div class="img" :style="{ backgroundImage: `url('${int.image}')` }"></div>
              </div> -->
              <div class="col-12 int__item--right">
                <div
                  class="int__item__content"
                >
                  <div class="row no-gutters">
                    <div class="col-sm-6 int__item__content--left ">
                      <BaseSectionTitle2 title="重要關注議題"/>
                    </div>
                    <div class="col-sm-6 int__item__content--right mt-md-0 mt-sm-4 mt-2" v-html="int.issue"></div>
                  </div>
                </div>
                <div
                  class="int__item__content"
                >
                  <div class="row no-gutters">
                    <div class="col-sm-6 int__item__content--left ">
                      <BaseSectionTitle2 title="公司的主要責任"/>
                    </div>
                    <div class="col-sm-6 int__item__content--right mt-md-0 mt-sm-4 mt-2" v-html="int.response"></div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>

        </el-tabs>
      </section>
      <section 
        v-if="!!currentList.contact.content || !!currentList.contact.person.length"
        class="int__contact section">
        <div class="int__contact__box">
          <h3 class="int__contact__title text-center">溝通管道及回應方式</h3>
          <hr class="my-2">
          <div 
            class="row "
            :class="{ 'justify-content-md-center': currentList.contact.person.length < 1 }"
          >
            <div
              v-for="(contactItem,$index2) in currentList.contact.person"
              :key="$index2"
              :class="[currentList.contact.person.length > 1 
                ? 'col-md-6 col-12 ' 
                : 'col-12']"
              class="int__contact__item"
            >
              <ul class="list-unstyled">
                <li v-if="contactItem.name">聯絡人：{{ contactItem.name }}</li>
                <li v-if="contactItem.phone">電話：{{ contactItem.phone }}</li>
                <li v-if="contactItem.email">E-mail：
                  <a
                    :href="`mailto:${contactItem.email}`"
                    class="color-primary hover:color-primary-hover text-decoration-none int__contact__link"
                    style="margin-left: -5px"
                  >
                    {{ contactItem.email }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div
            v-if="currentList.contact.content" 
            :class="[currentList.contact.person.length > 1 ? 'moreList' : 'singleList']"
            class="mx-auto int__contact__bottomList" 
            v-html="currentList.contact.content">

          </div>
          <!-- <ul
            :class="[currentList.person.length > 1 ? 'moreList' : 'singleList']"
            class="mx-auto int__contact__bottomList"
          >
            <li
              v-for="(contactList2,$index3) in currentList.content"
              :key="$index3">
              {{ contactList2 }}
            </li>
          </ul> -->
        </div>
      </section>
      <section v-if="!!currentList.report.length" class="int__contact section bg-white ">
        <div class="container isBorder">
          <div class="int__contact__box">
            <h3 class="int__contact__title text-center">利害關係人溝通情形報告</h3>
            <hr class="my-2">
            <p class="pt-4 color-gray-6 text-center text-base md:text-lg">歡迎查看利害關係人相關文件報告</p>
            <div class="int__contact__item">
              <File 
                v-for="(file, $index) in currentList.report"
                :key="$index"
                :item="file"
                class="file mb-2"
              />
            </div>
          </div>
        </div>

      </section>
    </div>
  </InvestorLayout>
</template>
<style lang="scss" module>
  .int {
    :global {
      .int {
        &__list {
          background: rgba(255, 255, 255, 1) 0% 0% no-repeat padding-box;
          border: 1px solid $color-gray-3;
          box-shadow: 0 2px 4px rgba(33, 69, 88, 0.16);
        }

        &__item {
          &--left {
            position: relative;
            min-height: 588px;
            // padding-top: 100%;
            overflow: hidden;

            @include max-md {
              min-height: 200px;
            }

            .img {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-image: url('~@assets/images/about/info.jpg');
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }
          }

          &--right {

          }

          &__content {
            &:not(:first-child) {
              position: relative;

              &::before {
                position: absolute;
                top: 0;
                right: 0;
                left: 0;
                width: 92%;
                height: 1px;
                margin: 0 auto;
                content: '';
                background: $color-gray-3;
                @include max-lg {
                  width: 86%;
                }
                @include max-md {
                  width: 95%;
                }
              }
            }

            &--left {
              padding: 60px 0 60px 60px !important;

              @include max-md {
                padding: 2rem 1rem 0 !important;
              }
            }

            &--right {
              padding: 60px 60px 60px 0 !important;

              @include max-md {
                padding: 0 1rem 2rem !important;
              }

              ul {
                padding-left: 20px;
                line-height: 1.75;
                color: $color-gray-6;
                list-style: none;

                li {
                  position: relative;
                  padding-left: 10px;
                  @include max-md {
                    font-size: 0.875rem;
                  }
                  &:not(:first-child) {
                    margin-top: 5px;
                  }
                }

                li::before {
                  position: absolute;
                  top: 10px;
                  left: -18px;
                  display: inline-block;
                  width: 12px;
                  height: 12px;
                  font-weight: bold;
                  color: $color-primary;
                  content: '';
                  background: $color-primary;
                  border-radius: 50%;
                  // margin-left: -1em;
                  // margin-right: 1.2em;
                  @include max-md {
                    width: 10px;
                    height: 10px;
                    top: 7px;
                  }
                }
              }
            }
          }
        }

        &__contact {
          // padding: 80px;
          background: $color-gray-2;
          // border-radius: 2px;
          // box-shadow: 0 2px 4px rgba(33, 69, 88, 0.16);
          // text-align: center;
          @include max-md {
            padding: 2rem 1rem;
            text-align: left;
            // margin-top: 70px;
          }

          > .isBorder {
            padding: 5rem $container-gap;
            border: 1px solid $color-gray-3;
            border-radius: 2px;

            @include max-md {
              padding: 3rem $container-gap;
            }
          }

          &__box {
            max-width: 876px;
            padding-right: $container-gap;
            padding-left: $container-gap;
            margin: 0 auto;

            @include max-md {
              padding-right: 0;
              padding-left: 0;
            }
          }

          &__title {
            position: relative;
            padding-bottom: 40px;
            font-size: 1.5rem;
            text-align: center;
            // border-bottom: 1px solid $color-gray-3;
            @include max-md {
              padding-bottom: 1rem;
              text-align: left;
              font-size: 1.25rem;
            }
            // &::before {
            //   position: absolute;
            //   right: 0;
            //   bottom: 0;
            //   left: 0;
            //   width: 80%;
            //   height: 1px;
            //   margin: 0 auto;
            //   content: '';
            //   background: $color-gray-3;
            //   @include max-md {
            //     width: 100%;
            //   }
            // }
          }

          &__item {
            display: flex;
            justify-content: center;
            margin-top: 40px;
            line-height: 1.75;

            @include max-md {
              margin-top: 1rem;
              font-size: 1rem;
            }

            li {
              &:not(:first-child) {
                margin-top: 5px;
              }

              a {
                transition: .3s;

                &:hover {
                  color: $color-primary-hover;
                }
              }
            }
          }

          &__bottomList {
            
            &.singleList {
              max-width: 417px;
            }

            &.moreList {
              max-width: 886px;
            }
            ul {
              list-style: none;
              display: flex;
              flex-direction: column;
              justify-content: center;
              width: 100%;
              padding-left: 18px;
              margin-top: 40px;
              line-height: 1.75;
              list-style: none;

              @include max-md {
                margin-top: 1rem;
              }

            }
            li {
              position: relative;
              padding-left: 10px;
              @include max-md {
                font-size: 0.875rem;
              }
              &:not(:first-child) {
                margin-top: 5px;
              }
            }

            li::before {
              position: absolute;
              top: 14px;
              left: -10px;
              display: inline-block;
              width: 3px;
              height: 3px;
              font-weight: bold;
              color: $color-gray-7;
              content: '';
              background: $color-gray-7;
              border-radius: 50%;
            }

          }

          .file {
            max-width: 420px;
            background: #FFF;

            @include max-md {
              max-width: 100%;
            }
          }
        }

        &__report {
          &__box {

          }

          &__item {
            max-width: 876px;
            margin: 4.4rem auto;

            @include max-md {
              padding: 2rem 1rem !important;
            }

          }
        }
      }

      .imgBox {

      }
    }
  }

</style>
